<template lang="pug">
section
  div
    | It is recommended
    | that you accompany your application
    | with a cover letter explaining your business,
    | need for employing migrants
    | and just that you understand
    | your future sponsor duties and responsibilities.
    | It will give the Home Office a sense of ‘confidence’
    | that you are a ‘low’ risk to abuse the system
    | and will be able to provide
    | genuine employment to migrants.

  br

  div
    | 🚀
    |
    span(style="background: #ccedeb")
      | Nation.better will prepare
      | a comprehensive Cover Letter
      | mentioning the most
      | crucial / necessary details
      | to support your application,
      | while mitigating risks of rejection
      | and boosting chances
      | of obtaining a sponsor licence
      | on the 1st attempt!
</template>

<script>
export default {
  name: "prepare_ao_cover_letter",
};
</script>